/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Precheck_IgnoreInputs */

const en_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore`)
};

const fr_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer`)
};

const de_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorieren`)
};

const it_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorare`)
};

const ru_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать`)
};

const es_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

const zh_cn2_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略`)
};

const ja_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無視する`)
};

const hi_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनदेखा करना`)
};

const pt_pt2_subtitle_export_precheck_ignore = /** @type {(inputs: Subtitle_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

/**
* | output |
* | --- |
* | "Ignore" |
*
* @param {Subtitle_Export_Precheck_IgnoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_precheck_ignore = /** @type {((inputs?: Subtitle_Export_Precheck_IgnoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Precheck_IgnoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_precheck_ignore(inputs)
	if (locale === "de") return de_subtitle_export_precheck_ignore(inputs)
	if (locale === "it") return it_subtitle_export_precheck_ignore(inputs)
	if (locale === "ru") return ru_subtitle_export_precheck_ignore(inputs)
	if (locale === "es") return es_subtitle_export_precheck_ignore(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_precheck_ignore(inputs)
	if (locale === "ja") return ja_subtitle_export_precheck_ignore(inputs)
	if (locale === "hi") return hi_subtitle_export_precheck_ignore(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_precheck_ignore(inputs)
	return en_subtitle_export_precheck_ignore(inputs)
});